import http from '../../axios-config/g-http-metodos';

function getClientes(FiltroNome) {
  const { res, erro, requisicao } = http.get(`Cliente/get/${FiltroNome}`)
  return { ClientesArray: res, erro, requisicao }
}

function getClienteDropDownsByNome(filtroNome, representanteId, empresaId) {
  let url = "Cliente/GetClienteDropDownsByNome"

  const params = {
    filtroNome:filtroNome,
    representanteId:representanteId,
    empresaId:empresaId
  }

  const { res, erro, requisicao } = http.get(url,0,params)
  return { ClientesArray: res, erro, requisicao }
}

function getClienteDropDownsById(representanteId, empresaId, clienteId) {
  const { res, erro, requisicao } = http.get(`Cliente/GetClienteDropDownsById/${representanteId}/${empresaId}/${clienteId}`)
  return { ClientesArray: res, erro, requisicao }
}

function getClientesAtivos() {
  const { res, erro, requisicao } = http.get('ClienteAtivos/Get')
  return { ClientesArray: res , erro, requisicao }
}

function getClientesMenosResponsavel (clienteId) {
  const { res, erro, requisicao } = http.get(`Cliente/GetClientesMenosClienteResponsavel/${clienteId}`)
  return { ClientesArray: res , erro, requisicao }
}

function GetClienteCreditoByClienteIdEmpresaId (clienteId, empresaId) {
  const { res, erro, requisicao } = http.get(`Cliente/GetClienteCreditoByClienteIdEmpresaId/${clienteId}/${empresaId}`)
  return { ClientesArray: res , erro, requisicao }
}

function confereCnpj (data) {
  const { res, erro, requisicao } = http.post(`Cliente/cnpjComApi`, data)
  return { res , erro, requisicao }
}

function getClienteByOrcamento(orcamentoId){
  const{ res, erro, requisicao} = http.get(`Cliente/GetClienteByOrcamento/${orcamentoId}`)
  return{ Cliente : res , erro, requisicao}

}

function GetCnpj(cnpj){
  const{ res, erro, requisicao} = http.get(`Cliente/verificaCNPJ/${cnpj}`)
  return{ Cliente : res , erro, requisicao}

}

function getClientesByFiltro(filtros) {
  const { res, erro, requisicao } = http.postArray(`Cliente/GetClientesByFiltro`, filtros)
  return { ClientesArray: res , erro, requisicao }
}

function getClientesByRepresentante() {
  const {res, erro, requisicao } = http.get(`Cliente/GetClientesByRepresentanteId`)
  return { ClientesArray: res, erro, requisicao }
}

function GetAllClientesByEmpresaIdEFiltro(EmpresaId, FiltroNome) {
  const { res, erro, requisicao } = http.get(`Cliente/GetAllClientesByEmpresaIdEFiltro/${EmpresaId}/${FiltroNome}`)
  return { ClientesArray: res, erro, requisicao }
}

function getClienteTipo(){
  const { res, erro, requisicao } = http.get('/ClienteTipo/Get')
  return { Segmentos: res, erro, requisicao }
}

function getClienteByEmpresaRepresentanteNome(empresaId, represantanteId, pesquisaEscrita){
  const { res, erro, requisicao } = http.get(`Cliente/GetClienteByEmpresaRepresentanteNome/${empresaId}/${represantanteId}/${pesquisaEscrita}`);
  return { ClientesArray: res, erro, requisicao };
}

function cadastraClienteFichaCadastral(data){
  const { res, erro, requisicao } = http.post(`Cliente/CadastraClienteFichaCadastral`, data)
  return { res, erro, requisicao };
}

function EditarClienteById(clienteId){
  const { res, erro, requisicao } = http.get(`Cliente/EditarClienteById/${clienteId}`);
  return { res, erro, requisicao };
}


function GetClientesDropdownPedidoEntrega(FiltroNome, representanteId, empresaId, pedidoId) {
  const { res, erro, requisicao } = http.get(`Cliente/GetClientesDropdownPedidoEntrega/${FiltroNome}/${representanteId}${empresaId ? '/' + empresaId : ''}${pedidoId ? '/' + pedidoId : ''}`)
  return { ClientesArray: res, erro, requisicao }
}

function GetTelefoneClienteById(clienteId = ""){
  const { res, erro, requisicao } = http.get(`Cliente/GetTelefoneClienteById/${clienteId}`)
  return { res: res, erro, requisicao }

}

function EhRepresentanteAdministrador(representanteId = ""){
  const { res, erro, requisicao } = http.get(`Cliente/EhRepresentanteAdministrador/${representanteId}`)
  return { res: res, erro, requisicao }

}


const ClienteController = {
  getClientes,
  getClientesAtivos,
  getClientesMenosResponsavel,
  getClienteDropDownsByNome,
  confereCnpj,
  getClienteByOrcamento,
  GetCnpj,
  getClientesByFiltro,
  getClientesByRepresentante,
  getClienteTipo,
  cadastraClienteFichaCadastral,
  GetAllClientesByEmpresaIdEFiltro,
  getClienteByEmpresaRepresentanteNome,
  EditarClienteById,
  getClienteDropDownsById,
  GetClienteCreditoByClienteIdEmpresaId,
  GetClientesDropdownPedidoEntrega,
  GetTelefoneClienteById,
  EhRepresentanteAdministrador
}

export default ClienteController
